import Base from "./base"

export default class Authenticate extends Base {
  constructor(Vue, store) {
    super("authenticate", Vue, store)
    this.routes = {1: "AdminLogin", 2: "UserLogin", 3: "GuestLogin"}
  }

  async before(to, from, next) {
    const slug = to.params.slug

    if (_.isNull(slug)) {
      next({name: "NotFound"})
      return
    }

    await this.store.dispatch("auth/selfByEvent", slug)
    const userId = this.store.getters["auth/id"]

    // ユーザ情報が空でないか判定
    if (_.isEmpty(this.store.getters["auth/user"]) || !userId) {
      this.store.commit("loading/setLoading", false)

      // ユーザ情報がないが、userIdがある場合は対象のログイン画面へ、それ以外は一旦UserLoginへ遷移させる
      const routeName = userId ? this.routes[userId.charAt(0)] : "UserLogin"
      next({name: routeName, params: {slug: slug}})
      return
    }

    next()
  }
}
